import { isAuthenticated } from 'user-auth'
import {
  GetMapByIdQuery,
  GetMapByIdQueryVariables
} from '~map-preview/types/__generated/gql/graphql'

import { graphql as publicGraphql } from 'ms-client/graphql/api-key'
import { graphql as privateGraphql } from 'ms-client/graphql/user-pool'

export type GetMapByIdResults = GetMapByIdQuery['getMapById']

const parseNodes = (node: string) => JSON.parse(node)

const getMapById = async (
  variables: GetMapByIdQueryVariables
): Promise<GetMapByIdResults> => {
  const authenticated = await isAuthenticated()

  const graphql = authenticated ? privateGraphql : publicGraphql

  const { getMapById: map } = await graphql<
    GetMapByIdQuery,
    GetMapByIdQueryVariables
  >({
    query: getMapByIdQuery,
    variables
  })

  const { readme } = map
  if (readme) readme.nodes = readme.nodes.map(parseNodes)

  return {
    ...map,
    readme
  }
}

const getMapByIdQuery = /* GraphQL */ `
  query GetMapById($id: ID!, $embedKey: String) {
    getMapById(id: $id, embedKey: $embedKey) {
      id
      createdAt
      updatedAt
      dataId
      dataReady
      name
      description
      views
      likes
      remixes
      bbox
      centroid
      isPublic
      liked
      embedKey
      properties {
        name
        type
        visualisation
        isAggregate
        isPercentage
        isDefaultVisualisation
        isTitle
        classBreaks
        visible
        options {
          fieldType
          format
          decimalPlace
          currencyValue
          aggregate
        }
      }
      license {
        name
        url
      }
      source {
        name
        url
      }
      readme {
        nodes
        createdAt
        updatedAt
        isOpenByDefault
      }
      workspace {
        id
        inviteId
        name
        description
        logo
        createdAt
        memberCollection {
          total
          items {
            user {
              id
              firstName
              lastName
              avatar
              email
            }
          }
        }
        guestCollection {
          total
          items {
            user {
              id
              firstName
              lastName
              avatar
              email
            }
          }
        }
      }
      creator {
        id
        firstName
        lastName
        email
        avatar
        createdAt
      }
      parentMap {
        id
        name
        workspace {
          id
          name
        }
        creator {
          id
          firstName
          lastName
        }
      }
      mapTagCollection {
        total
        items {
          tag {
            id
            name
            description
            type
            categoryType
            count
          }
        }
      }
      defaultVisualization {
        marker {
          id
          type
        }
        cluster {
          id
          type
        }
        heatmap {
          id
          type
        }
        category {
          id
          type
          property
        }
        aggregate {
          id
          type
          property
          display
          aggregate
        }
        hexagon {
          id
          type
          property
          size
          display
          aggregate
        }
      }

      mapRemixCollection {
        total
      }
      type
      mapGuestAccessCollection {
        total
        items {
          id
          workspaceId
          userId
          mapId
          createdAt
          user {
            id
            firstName
            lastName
            email
            avatar
            createdAt
          }
          invitedUser {
            id
            email
            createdAt
          }
        }
      }
    }
  }
`

export { getMapById, getMapByIdQuery }
